import { HttpErrorResponse } from '@angular/common/http';

export const DomainErrorCodeMap = {
  TooManyMatchingLineItems: -4867,
  AuthProviderUnavailable: -6160,
  AuthTokenInvalid: -6161,
} as const;

export type DomainErrorCode = (typeof DomainErrorCodeMap)[keyof typeof DomainErrorCodeMap];

/**
 * Retrieves the domain error code from a given error object.
 *
 * @param {unknown} error - The error object to extract the domain error code from.
 * @returns {DomainErrorCode | undefined} The matching domain error code if found, otherwise undefined.
 */
export function getDomainErrorCode(error: unknown): DomainErrorCode | undefined {
  if (!(error instanceof HttpErrorResponse)) {
    return;
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
  const code = error.error?.code;
  if (typeof code !== 'number') {
    return;
  }

  return Object.values(DomainErrorCodeMap).find((errorCode) => errorCode === code);
}
